class OffCanvas extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((theme.off_canvas = this).focus_triggers = this.querySelectorAll(
      ".off-canvas--focus-trigger"
    )),
      (this.left_sidebar = this.querySelector(".off-canvas--left-sidebar")),
      (this.main_content = this.querySelector(".off-canvas--main-content")),
      (this.overlay = this.querySelector(".off-canvas--overlay")),
      (this.right_sidebar = this.querySelector(".off-canvas--right-sidebar")),
      (this.state = "closed"),
      this.load();
  }
  load() {
    (this.close = document.querySelectorAll("[data-off-canvas--close]")),
      (this.triggers = document.querySelectorAll("[data-off-canvas--open]")),
      this.setViewPortHeight(),
      this.viewPortHeightListener(),
      this.toggleListeners(),
      this.touchListener(),
      this.closeListeners(),
      this.transitionListeners();
  }
  reset() {
    [...this.triggers, this.overlay, this.close].forEach((t) =>
      t.off("click keydown")
    ),
      this.load();
  }
  setState(t) {
    (this.state = t),
      this.setAttribute("data-off-canvas--state", t),
      "left--opening" === this.state &&
        (this.left_sidebar.setState("forwards"),
        this.overlay.setState("forwards")),
      "left--closing" === this.state &&
        (this.left_sidebar.setState("backwards"),
        this.overlay.setState("backwards")),
      "right--opening" === this.state &&
        (this.right_sidebar.setState("forwards"),
        this.overlay.setState("forwards")),
      "right--closing" === this.state &&
        (this.right_sidebar.setState("backwards"),
        this.overlay.setState("backwards"));
  }
  setViewPortHeight() {
    this.style.minHeight = window.innerHeight + "px";
  }
  viewPortHeightListener() {
    window.on("resize", () => this.setViewPortHeight());
  }
  toggleListeners() {
    this.triggers.on("click keydown", (t) => {
      if ("keydown" !== t.type || "Enter" === t.key) {
        this.last_trigger = t.target;
        var e = this.last_trigger.getAttribute("data-off-canvas--open"),
          i = this.last_trigger.getAttribute("data-handle");
        if ("left-sidebar" === e) this.toggle("left-sidebar");
        else if ("right-sidebar" === e) {
          if (
            (this.toggleView(
              this.last_trigger.getAttribute("data-off-canvas--view")
            ),
            "product-form" === this.right_sidebar_view)
          )
            theme.quick_add.initForm(this.last_trigger);
          else if ("filter" === this.right_sidebar_view) {
            var s = this.last_trigger.getAttribute("data-toggle-menu");
            window.trigger("theme:navigation:toggleFilterMenu", s);
          } else if ("cart" === this.right_sidebar_view && i)
            return (
              t.preventDefault(),
              t.stopPropagation(),
              theme.quick_add.addToCart(this.last_trigger),
              !1
            );
          this.toggle("right-sidebar");
        }
        t.preventDefault(), t.stopPropagation();
      }
    }),
      [...this.close, this.overlay].on("click keydown", (t) => {
        ("keydown" === t.type && "Enter" !== t.key) ||
          ("left--opened" === this.state
            ? this.toggle("left-sidebar")
            : "right--opened" === this.state && this.toggle("right-sidebar"));
      });
  }
  closeListeners() {
    window.on("keydown", (t) => {
      "Escape" === t.key &&
        ("left--opened" === this.state
          ? this.toggle("left-sidebar")
          : "right--opened" === this.state && this.toggle("right-sidebar"));
    }),
      this.focus_triggers.on("focus", () => {
        "left--opened" === this.state
          ? this.toggle("left-sidebar")
          : "right--opened" === this.state && this.toggle("right-sidebar");
      });
  }
  toggleView(t) {
    this.right_sidebar.setAttribute("data-active", t),
      (this.right_sidebar_view = t);
  }
  toggle(t) {
    "left-sidebar" === t && "closed" === this.state
      ? this.openLeft()
      : "left-sidebar" === t && "left--opened" === this.state
      ? this.closeLeft()
      : "right-sidebar" === t && "closed" === this.state
      ? this.openRight()
      : "right-sidebar" === t &&
        "right--opened" === this.state &&
        this.closeRight();
  }
  openLeft() {
    this.state.includes("right--open") && this.closeRight(),
      (this.style.overflow = "hidden"),
      (this.left_sidebar.style.display = "block"),
      (this.window_offset = window.pageYOffset),
      this.main_content.setStyles({
        top: `-${this.window_offset}px`,
        position: "fixed",
      }),
      this.setState("left--opening"),
      window.trigger("theme:offCanvas:leftOpening"),
      window.scrollTo(0, 0);
  }
  openRight() {
    this.state.includes("left--open") && this.closeLeft(),
      (this.style.overflow = "hidden"),
      (this.right_sidebar.style.display = "block"),
      (this.window_offset = window.pageYOffset),
      this.main_content.setStyles({
        top: `-${this.window_offset}px`,
        position: "fixed",
      }),
      this.setState("right--opening"),
      window.trigger("theme:offCanvas:rightOpening"),
      window.scrollTo(0, 0);
  }
  openComplete(t) {
    let e;
    "right-sidebar" === t
      ? ((e = this.right_sidebar.querySelector(
          `[data-view='${this.right_sidebar_view}']`
        )),
        window.trigger("theme:offCanvas:rightOpened"))
      : "left-sidebar" === t &&
        ((e = this.left_sidebar.querySelector("[data-view='menu']")),
        window.trigger("theme:offCanvas:leftOpened"));
    var i = theme.a11y.getFocusableEl(e);
    i && i.length && i[0].focus();
  }
  closeLeft() {
    this.setState("left--closing"),
      window.trigger("theme:offCanvas:leftClosing"),
      this.last_trigger && this.last_trigger.focus();
  }
  closeRight() {
    this.setState("right--closing"),
      window.trigger("theme:offCanvas:rightClosing"),
      this.last_trigger && this.last_trigger.focus();
  }
  closeComplete(t) {
    (this.style.overflow = "unset"),
      (("right" === t ? this.right_sidebar : this.left_sidebar).style.display =
        "none"),
      window.trigger(`theme:offCanvas:${t}Closed`),
      this.main_content.setStyles({ top: "initial", position: "relative" }),
      window.scrollTo(0, this.window_offset);
  }
  touchListener() {
    theme.utils.isTouchDevice &&
      (window.on("theme:swipe:left", () => {
        "left--opened" === this.state && this.toggle("left-sidebar");
      }),
      window.on("theme:swipe:right", () => {
        "right--opened" === this.state && this.toggle("right-sidebar");
      }));
  }
  transitionListeners() {
    this.overlay.on("transition:at_start", () => {
      var t = this.state.includes("right") ? "right" : "left";
      this.setState("closed"), this.closeComplete(t);
    }),
      this.overlay.on("transition:at_end", () => {
        "left--opening" === this.state &&
          (this.setState("left--opened"), this.openComplete("left-sidebar")),
          "right--opening" === this.state &&
            (this.setState("right--opened"),
            this.openComplete("right-sidebar"));
      });
  }
}
customElements.define("off-canvas-root", OffCanvas);

